import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, ShieldKeyholeIcon, Text } from "@fluentui/react-northstar";
import { translations } from "../../../translations";
import { useTranslate } from "../../../hook/useTranslate";
import { heroIconStyles, mutedTextStyles, softBrandStyles } from "../dialogThemeStyles";
const roleBadgeStyles = (params) => ({
    ...softBrandStyles(params),
    borderRadius: "999px",
    padding: "0.125rem 0.625rem",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
});
/**
 * An admin without a licence, in a tenant that still has seats: what they can do (take one, no purchase)
 * before the button that opens the assignment page. Shared by the Premium and the upgrade dialogs.
 */
export const AdminLicenceContent = (props) => {
    const t = useTranslate(translations);
    return (_jsxs(Flex, { column: true, hAlign: "center", gap: "gap.small", styles: { paddingTop: "0.5rem" }, "data-testid": "admin-licence-content", children: [_jsx(Flex, { hAlign: "center", vAlign: "center", styles: heroIconStyles, children: _jsx(ShieldKeyholeIcon, { size: "large", outline: true }) }), _jsx(Text, { size: "smaller", weight: "semibold", styles: roleBadgeStyles, content: t("AdminLicence:Badge") }), _jsx(Text, { align: "center", size: "larger", weight: "bold", content: t("AdminLicence:Title", { plan: props.planName }) }), _jsx(Text, { align: "center", styles: mutedTextStyles, content: t("AdminLicence:Subtitle", { appTitle: props.appTitle }) }), _jsx(Text, { align: "center", size: "small", styles: mutedTextStyles, content: t("AdminLicence:Hint") })] }));
};
